import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38220cdb"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=38220cdb&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38220cdb')) {
      api.createRecord('38220cdb', component.options)
    } else {
      api.reload('38220cdb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38220cdb", function () {
      api.rerender('38220cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/usermanager/index.vue"
export default component.exports